enum NavigationAction {
  BACK = 'BACK',
  FORWARD = 'FORWARD'
}

enum ProcessRunType {
  MANUAL = 'MANUAL',
  PREDICTION = 'PREDICTION',
  SOURCE = 'SOURCE',
  CQA = 'CQA'
}

enum EntriesMessageType {
  ADT = 'Registration',
  SIU = 'Surgery',
  ORM = 'Orders',
  RDS = 'Medication',
  MDM = 'Notes',
  DFT = 'Charges'
}

enum CodeChangeType {
  UPDATE = 'UPDATE',
  ADD = 'ADD',
  DELETE = 'DELETE',
  SEARCH_DROP = 'SEARCH_DROP'
}

enum ProcessStatus {
  PROCESS_CREATED = 'Process Created',
  WAITING_FOR_DATA = 'Waiting for data',
  DATA_COLLECTED = 'Data Collected',
  PREDICTION_IN_PROGRESS = 'Prediction in Progress',
  PREDICTED = 'Predicted',
  MANUAL = 'Manual',
  AT_CODER = 'At Coder',
  DONE = 'Done',
  ERROR = 'Error'
}

enum AccelerateProcessStatus {
  /*
  Pre-coder states
  */
  WAITING_FOR_IMPORT = 'WAITING_FOR_IMPORT',
  IMPORTING = 'IMPORTING',
  RETRY_IMPORT = 'RETRY_IMPORT',
  /*
  Coder states
   */
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',

  /*
  Post-coder states
   */
  WAITING_FOR_SEND = 'WAITING_FOR_SEND',
  SENDING = 'SENDING',
  SENT = 'SENT',
  RETRY_SEND = 'RETRY_SEND',
  LATE_CASE_UPDATE = 'LATE_CASE_UPDATE',

  /*
  Canceled and Replaced state
   */
  CANCELLED = 'CANCELLED',
  REPLACED = 'REPLACED',
  REPLACED_CANCELLED = 'REPLACED_CANCELLED',

  REMOVED = 'REMOVED'
}

enum ProcessQAStatus {
  IN_QA = 'IN_QA',
  QA_COMPLETE = 'QA_COMPLETE'
}

enum CaseStatus {
  DORMANT = 'Dormant',
  DONE = 'Done',
  CASE_CREATED = 'Case Created',
  IN_PROCESS = 'In Process',
  DATA_COLLECTED = 'Data Collected',
  CANCELLED = 'Cancelled',
  DID_NOT_CODE = 'Did not code'
}

enum CodeType {
  DIAGNOSIS = 'diagnosis',
  PROCEDURE = 'procedure',
  TECHNICAL_CHARGE = 'TECHNICAL',
  CPT = 'CPT',
  ICD = 'ICD',
  MODIFIER = 'MODIFIER'
}

enum EvidenceType {
  MAPPED = 'mapping',
  PARTIAL = 'partial',
  COMPLETE = 'complete'
}

enum EditorIssueLevel {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  UNKNOWN = 'UNKNOWN'
}

enum EditorIssueProvenance {
  CCI = 'CCI',
  CLAIMS = 'CLAIMS',
  CUSTOM_RULES = 'CUSTOM_RULES'
}

enum Gen2CaseStatus {
  CREATED = 'Created',
  IN_PROGRESS = 'In Progress',
  CANCELLED = 'Cancelled',
  MANUAL = 'Manual',
  AUTOMATED = 'Automated',
  UPDATED_MANUAL = 'Updated - Manual', // legacy status for late case update from path
  DORMANT = 'Dormant',
  CLOSED_NEW_VERSION = 'Closed - New Version'
}

enum Gen2ProcessStatus {
  PROCESS_CREATED = 'Process Created',
  IN_PROGRESS = 'In Progress',
  DATA_AGGREGATION = 'Data Aggregation',
  RESULTS_HOLD = 'Results Hold',
  WAITING_FOR_DATA = 'Waiting for Data',
  DATA_COLLECTED = 'Data Collected',
  PREDICTED = 'Predicted',
  PREDICTION_FAILED = 'Prediction Failed',
  SENDING_TO_CODER = 'Sending To Coder',
  AT_CODER = 'At Coder',
  CODES_RECEIVED = 'Codes Received',
  NO_FEEDBACK = 'No Feedback',
  ADDED_TO_GROUP = 'Added to Group',
  READY_TO_SUBMIT_GROUP = 'Ready to Submit Group',
  BILLING_HOLD = 'Billing Hold',
  READY_TO_EXPORT = 'Ready to Export',
  BILLING_EXPORT_HOLD = 'Billing Export Hold',
  TERMINATED = 'Terminated',
  DONE = 'Done',
  EXPIRED = 'Expired',
  ERROR = 'Error'
}

enum uiStatus {
  IN_PROGRESS = 'In Progress',
  IN_PROCESS = 'In Process',
  WAITING = 'Waiting For Coder',
  MANUAL = 'Manual',
  DORMANT = 'Dormant',
  CANCELLED = 'Cancelled',
  AUTOMATED = 'Automated',
  UPDATED_MANUAL = 'Updated - Manual',
  CLOSED_NON_CHARGEABLE = 'Closed Non-chargeable'
}

enum CaseDataTypes {
  DATE = 'DATE',
  BOOLEAN = 'BOOLEAN',
  IDENTIFIER_ISSUER = 'IDENTIFIER_ISSUER',
  IDENTIFIER_NUMBER = 'IDENTIFIER_NUMBER'
}

enum CaseDataGroup {
  PATIENT = 'patient',
  ORGANIZATION = 'organization',
  ENCOUNTER = 'encounter',
  ORDER = 'order',
  BILLING = 'billing',
  CMX = 'cmx'
}

enum IdentifierType {
  MRN = 'MRN',
  VISIT_NUMBER = 'VISIT_NUMBER',
  APPOINTMENT_NUMBER = 'APPOINTMENT_NUMBER'
}

enum SystemRole {
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
  COORDINATOR = 'coordinator',
  CODER = 'coder',
  DEMO = 'demo',
  USER_MANAGER = 'user_manager',
  EXTERNAL_SYSTEM = 'external_system',
  SYSTEM = 'system'
}

enum ResourceTypes {
  'UI' = 'ui'
}

enum TaskTypes {
  BUSINESS_RULE = 'businessRuleTask',
  START_EVENT = 'conditionalStartEvent',
  SERVICE_CALL = 'serviceTask',
  END_EVENT = 'terminateEndEvent'
}

enum CustomerPhase {
  TESTING = 'TESTING',
  PARALLEL = 'PARALLEL',
  ACTIVE = 'ACTIVE',
  LIVE = 'LIVE',
  PRODUCTION = 'PRODUCTION'
}

enum OrgLevels {
  BUSINESS = 0,
  HEALTH_SYSTEM = 1,
  HOSPITAL = 2,
  PHYSICIAN_ORGANIZATION = 3
}

enum ORGS {
  BUSINESS = 'BUSINESS',
  HEALTH_SYSTEM = 'HEALTH_SYSTEM',
  HOSPITAL = 'HOSPITAL',
  PHYSICIAN_ORGANIZATION = 'PHYSICIAN_ORGANIZATION'
}

enum FilterTypes {
  IN = 'IN',
  LIKE = 'LIKE',
  EQ = 'EQ',
  BETWEEN = 'BETWEEN'
}

enum FilterKeys {
  TENANT = 'tenant_code',
  PROCEDURE_TYPE_CATEGORY = 'procedure_type_category',
  CASE_STATUS = 'case_status',
  DATE_OF_SERVICE = 'date_of_service',
  DATE_OF_AUTOMATION = 'date_of_automation'
}

enum FeatureSources {
  NOTE = 'raw_body',
  NOTE_CONVERTED = 'body',
  BODY_REGION = 'body_region',
  PROCEDURE_TYPE = 'procedure_type',
  PROCEDURE_CATEGORY = 'procedure_category',
  EXAM_DESCRIPTION = 'exam_description',
  EXAM_TYPE = 'exam_type',
  REASON_FOR_VISIT = 'reason_for_visit',
  WORK_QUEUE_NAME = 'work_queue_name'
}

enum FeatureTypes {
  MAPPING = 'MAPPING',
  NGRAM = 'ngram',
  CATEGORICAL = 'categorical',
  PRIOR = 'prior'
}

enum Provenances {
  CLINICAL = 'source',
  PREDICTION = 'CMX',
  MANUAL = 'manual',
  CQA = 'cqa'
}

enum ArtifactTypes {
  CODED = 'submission to payer',
  MAPPED = 'dictionary lookups (internal)',
  CLINICAL = 'source system',
  CLAIM = 'historical data',
  PREDICTION = 'CodaMetrix Prediction Engine',
  PROCESSED = 'CodaMetrix',
  SUBMITTED = 'CodaMetrix',
  REMITTANCE = 'a response to the payer',
  REFERRAL = 'referral',
  MANUAL = 'manual',
  CQA = 'CodaMetrix QA'
}

// This enum is sorted by the order which these artifacts are created in automate
//https://codametrix.atlassian.net/wiki/spaces/DEV/pages/3654778881/Invoice+Assembly+-+Invoice+Types
enum CaseArtifactTypes {
  CLINICAL = 'CLINICAL',
  MAPPED = 'MAPPED',
  PREDICTION = 'PREDICTION',
  ASSEMBLED = 'ASSEMBLED',
  CODED = 'CODED',
  PROCESSED = 'PROCESSED',
  SUBMITTED = 'SUBMITTED',
  CLAIM = 'CLAIM',
  REFERRAL = 'REFERRAL',
  REMITTANCE = 'REMITTANCE'
}

// This enum is sorted by the order which these invoices are created in automate
//https://codametrix.atlassian.net/wiki/spaces/DEV/pages/3654778881/Invoice+Assembly+-+Invoice+Types
enum InvoiceTypes {
  CLINICAL = 'CLINICAL',
  MAPPED = 'MAPPED',
  // Prediciton invoice is a UI specific invoice for retrieving predicted codes regardless of confidence/what is on the assembled invoice
  PREDICTION = 'PREDICTION',
  ASSEMBLED = 'ASSEMBLED',
  CODED = 'CODED',
  PROCESSED = 'PROCESSED',
  SUBMITTED = 'SUBMITTED',
  CLAIM = 'CLAIM',
  REFERRAL = 'REFERRAL',
  REMITTANCE = 'REMITTANCE',
  SHARED_CODES = 'SHARED_CODES'
}

enum IdentifierTypes {
  PATIENT_IDENTIFIER = 'PATIENT_IDENTIFIER',
  PROVIDER_IDENTIFIER = 'PROVIDER_IDENTIFIER',
  PLACER_ORDER_NUMBER = 'PLACER_ORDER_NUMBER',
  FILLER_ORDER_NUMBER = 'FILLER_ORDER_NUMBER',
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
  VISIT_NUMBER = 'VISIT_NUMBER'
}

enum statusColors {
  IN_PROGRESS = '#d67670',
  WAITING = '#dddddd',
  AUTOMATED = '#39c1ce',
  MANUAL = '#43488a',
  CANCEL = '#f5b940',
  UPDATED_MANUAL = '#88438a'
}

enum statusBGColors {
  IN_PROGRESS = 'rgba(214, 118, 112, .2)',
  AUTOMATED = 'rgba(57, 193, 206, .2)',
  MANUAL = 'rgba(67, 72, 138, .2)',
  WAITING = 'rgba(0, 0, 0, .2)',
  CANCEL = 'rgba(245, 185, 64, .2)',
  UPDATED_MANUAL = 'rgba(136, 67, 138, .2)'
}

enum AuthToken {
  REQUEST = 'TOKEN_REQUEST',
  RESPONSE = 'TOKEN_RESPONSE'
}

enum SpanLevel {
  SENTENCE = 'sentence',
  NGRAM = 'ngram'
}

enum TimelineStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  STARTED = 'STARTED'
}

enum DictionaryStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived'
}

enum DictionaryEditStatus {
  DELETE = 'delete',
  UPDATE = 'update',
  ADD = 'add',
  RETIRE = 'retire'
}

enum CaseDetailMode {
  EDIT = 'code-edit',
  DASHBOARD = 'dashboard',
  QA = 'cqa'
}

enum ChargeSessionType {
  PROFESSIONAL = 'professional',
  TECHNICAL = 'technical',
  PRO_TECH = 'pro-tech'
}
enum ChargeSessionCodeType {
  DIAGNOSIS = 'diagnosis',
  PROCEDURE = 'procedure',
  MODIFIER = 'modifier'
}

enum ChargeSessionCodeProvenance {
  ICD = 'ICD',
  CPT = 'CPT',
  HCPCS = 'HCPCS',
  TECH = 'TECH',
  MODIFIER = 'MODIFIER'
}
enum ChargeSessionProviderRole {
  PERFORMING = 'performing_provider',
  BILLING = 'billing_provider',
  BILLING_ASSISTANT = 'billing_provider_assistant',
  ORDERING = 'ordering_provider',
  REFERRING = 'referring_provider',
  RENDERING = 'rendering_provider'
}

enum ServiceLines {
  SURGERY = 'Surgery',
  RADIOLOGY = 'Radiology',
  PATHOLOGY = 'Pathology',
  AUTOMATE = 'Automate',
  BEDSIDE_PRO = 'Bedside Pro',
  BEDSIDE_PRO_NO_SPACE = 'BedsidePro',
  IPC_LONG_NAME = 'Inpatient Professional Coding',
  IPC = 'IPC',
  ALL = '*'
}

enum CrudOperations {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE'
}

enum InvoiceStatus {
  SUBMITTED = 'SUBMITTED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW'
}

enum InvoiceEditorMode {
  EDITOR = 'EDITOR',
  ADDITION = 'ADDITION'
}

enum UserPreferenceKey {
  DEFAULT_USER_CONTEXT = 'codametrix.user.preference.default_user_context',
  DEFAULT_USER_SERVICE_LINE = 'codametrix.user.preference.default_service_line',
  DEFAULT_HOMEPAGE = 'codametrix.user.preference.default_homepage',
  DEMOGRAPHICS_PANEL_LOCATION = 'codametrix.user.preference.demographics_panel_location',
  DEMOGRAPHICS_PANEL_VISIBILITY = 'codametrix.user.preference.demographics_panel_visibility'
}

enum UserPreferenceSection {
  USER_PREFERENCE = 'user_preference',
  USER_SECURITY = 'user_security'
}

//Valid Configuration Sections for /configuration/section/{ConfigurationSection}/... calls
enum ConfigurationSection {
  SUBNAV = 'subnav',
  CODER_CONFIG = 'coder_config'
}

enum ConfigurationKeyName {
  AMPLIFY_INVOICE_TYPES = 'amplify_invoice_types',
  MULTI_CODESET_GENERAL = 'multi_codeset_general_feature_flag',
  AUTOMATE_CHECK_CODE_SOURCE_PREDICTED_INVOICE = 'automate_check_code_source_predicted_invoice',
  CODE_SOURCE_DISPLAY_INVOICE_TYPES = 'code_source_display_invoice_types'
}

enum PermissionLevel {
  READ_ONLY = 'READ_ONLY',
  FULL_ACCESS = 'FULL_ACCESS',
  DENY = 'DENY'
}

enum ResourceId {
  SEARCH = 'search',
  CASES = 'cases',
  DASHBOARD = 'dashboard',
  ORGANIZATIONS = 'organizations',
  ASSIGNING_AUTHORITIES = 'assigning_authorities',
  METADATA = 'metadata',
  PROCESS_DEFINITION_MANAGEMENT = 'process_definition_management',
  ASSOCIATION_GROUP = 'association_group',
  DICTIONARY = 'dictionary',
  POWER_FEATURES = 'power_features',
  CASE_CONFIGURATION = 'case_configuration',
  CODE_CASE = 'code_case',
  ENABLE_RELATED_CASE_CODES_UI = 'enable_related_case_codes_ui',
  IMPORT_AMPLIFY = 'import_amplify',
  GROUPS = 'groups',
  VOID_CASE = 'void_case',
  MERGE_CASE = 'merge_case',
  CREATE_CASE = 'create_case',
  CODER_FEEDBACK = 'coder_feedback',
  TIMELINE_INFINITE_LOAD = 'timeline_infinite_load',
  ATTACH_DOCS = 'attach_docs',
  PRODUCTIVITY_TRACKER = 'productivity_tracker',
  DIAGNOSIS_CODE_SUGGESTION = 'diagnosis_code_suggestion',
  AMPLIFY_CASE_RUN_V2 = 'amplify_case_run_v2',
  CODER_NOTES = 'coder_notes',
  TRANSACTION_V2 = 'transaction_v2',
  GET_CASERUN_WITH_REFRESH = 'get_caserun_with_refresh',
  USE_PROVIDER_DIRECTORY_LOCATIONS = 'use_provider_directory_locations',
  MULTI_CODESET_FEATURE = 'multi_codeset_general_feature_flag',
  SHOW_RELATED_CASE_FILTER = 'show_related_cases_filter',
  WORKLIST_MAINTENANCE_WINDOW = 'worklist_maintenance_window',
  DISPLAY_ALL_CASE_RUNS = 'display_all_case_runs',
  USE_DATAACCESS_AMPLIFY = 'use_dataaccess_amplify'
}

enum CaseConfigSection {
  GENERAL = 'GENERAL'
}

enum FeedbackMeta {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

enum DictionaryRequestStatus {
  INITIALIZED = 'INITIALIZED',
  COMPLETED = 'COMPLETED',
  CELL_REFERENCE_VALIDATION_COMPLETED = 'CELL_REFERENCE_VALIDATION_COMPLETED',
  COLUMN_UPDATE_COMPLETED = 'COLUMN_UPDATE_COMPLETED',
  CSV_PARSE_COMPLETED = 'CSV_PARSE_COMPLETED',
  ROW_UPDATE_COMPLETED = 'ROW_UPDATE_COMPLETED'
}

enum ProcessInstanceActions {
  ALL_INVOICES = 'ALL_INVOICES',
  INVOICE_AVAILABLE = 'INVOICE_AVAILABLE',
  INVOICE_SUBMITTED = 'INVOICE_SUBMITTED',
  DASHBOARD_INVOICE_AVAILABLE = 'DASHBOARD_INVOICE_AVAILABLE',
  FETCH_SOURCE_INVOICES = 'FETCH_SOURCE_INVOICES'
}

enum AuthenticationChannelEvents {
  BOOTSTRAP_AUTH = 'bootstrapAuth',
  BOOTSTRAP_AUTH_RESPONSE = 'bootstrapAuthResponse',
  TOKEN_UPDATE = 'TOKEN_UPDATE'
}

enum UIModesEnum {
  EPIC_EMBEDDED = 'EPIC_EMBEDDED',
  STANDALONE = 'STANDALONE',
  PLAYGROUND = 'PLAYGROUND'
}

enum UIViewEnum {
  AUTOMATE = 'AUTOMATE',
  AMPLIFY = 'AMPLIFY'
}

enum ChargeTypes {
  TRACKING = 'tracking',
  STANDARD = 'standard',
  LEGACY = 'legacy', // this can be dropped after a period of time.
  UNKNOWN = 'unknown'
}

enum CodeTypes {
  PROCEDURE = 'procedure',
  MODIFIER = 'modifier'
}

enum ModifierTypes {
  PRO = 'PRO',
  TECH = 'TECH'
}

enum IssueTypeErrors {
  CLAIMS_EDIT = 'invoice.claims_edit.invalid',
  CCI_EDIT = 'invoice.cci_edit.invalid',
  CUSTOM_RULES = 'invoice.custom_rules.invalid'
}

enum AmplifyErrorSources {
  CLAIMS_EDIT = 'CLAIMS_EDIT',
  CCI_EDIT = 'CCI_EDIT',
  STANDARD = 'STANDARD',
  CUSTOM_RULES = 'CUSTOM_RULES',
  CUSTOM = 'CUSTOM',
  MERGE_SPLIT_HISTORY = 'MERGE_SPLIT_HISTORY',
  UNRESOLVED_DOCUMENT = 'UNRESOLVED_DOCUMENT',
  HOLD = 'HOLD'
}

// this file points to the parameters that are
// used in the EPIC launch cal.
enum LaunchParams {
  TRANSACTION_IDS = 'transactionIds',
  UCL_IDS = 'uclIds',
  PROVIDER_ID = 'providerID',
  PROVIDER_NAME = 'providerName',
  PATIENT_ID = 'patientIdentifier',
  VISIT_DATE = 'serviceDate',
  VISIT_CSN = 'visitNumber',
  EXTERNAL_USERNAME = 'external_username',
  LAUNCH_POINT = 'launchPoint'
}

enum CapabilityAvailabilityReason {
  /**
   * Whether a user's role prevents them from having access to a feature.
   */
  ROLE = 'ROLE',
  /**
   * Whether a feature is not generally available.
   */
  EMBARGO = 'EMBARGO',
  /**
   * Whether a product mis-match prevents a feature from being available to the user.
   */
  PRODUCT_EXCLUDED = 'PRODUCT_EXCLUDED',
  /**
   * Whether a configuration (usually driven by an org config) prevents a feature from being available.
   */
  CONFIGURATION = 'CONFIGURATION'
}

enum AmplifyCapabilities {
  coding = 'coding',
  improvements = 'improvements',
  pagination = 'pagination',
  cancelCase = 'cancelCase',
  submitCase = 'submitCase',
  viewOnlyCase = 'viewOnlyCase',
  holdCase = 'holdCase',
  toggleChargeableCase = 'toggleChargeableCase',
  caseEdit = 'caseEdit',
  attachDocs = 'attachDocs',
  productivityTracker = 'productivityTracker',
  codeSourcesFeatures = 'codeSourcesFeatures'
}

enum DocumentStatus {
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED',
  INCOMPLETE = 'INCOMPLETE',
  NOT_CORRECTED = 'NOT_CORRECTED'
}

enum DocumentQueryType {
  REQUIRED = 'Yes',
  CODERS_CHOICE = 'Yes/No',
  NOT_REQUIRED = 'NO',
  NO_LOG = 'No-Log'
}

enum ProcessStatusLabel {
  AUTOMATE = 'Automate',
  IMPORTING = 'Importing',
  READY_FOR_CODING = 'Ready for coding',
  VOIDED = 'Voided',
  SUBMITTED = 'Submitted',
  NON_CHARGEABLE = 'Non-Chargeable',
  IN_QA = 'In QA'
}

enum ImprovementDictionaryProps {
  DESCRIPTION = 'Documentation Improvement Opportunity Description',
  SEND_QUERY = 'Send Query',
  EPIC_QUERY_TEMPLATE = 'Epic Query Template',
  KEY = 'Key',
  ERROR_CODE = 'Error Code'
}

enum HoldReasonType {
  HOLD = 'HOLD',
  HOLD_FOR_DOCUMENTATION_QUERY = 'HOLD_FOR_DOCUMENTATION_QUERY',
  HOLD_FOR_MANAGER_REVIEW = 'HOLD_FOR_MANAGER_REVIEW',
  OFF_HOLD = 'OFF_HOLD'
}

enum CaseAccessState {
  /**
   * No access to the case - not acquired or released
   * Alternativley can be termed as "FREE"
   */
  NONE = 'NONE',
  /**
   * Case access has been successfully acquired by current user
   */
  ACQUIRED = 'ACQUIRED',
  /**
   * Case access conflict - another user has access
   */
  CONFLICT = 'CONFLICT'
  // TODO: Consider adding additional states in the future:
  // - ACQUISITION_FAILED: Case access acquisition failed
  // - RELEASING: Case access is being released
  // - RELEASED: Case access has been successfully released
  // - RELEASE_FAILED: Case access release failed
  // - REFRESHING: Case access timer is being refreshed
}

enum TitleTabsEnum {
  CHANGES_TEXT = 'See changes to this case'
}

enum MiniTabLabels {
  CHARGES_LABEL = 'Charges',
  RELATED_LABEL = 'Related',
  ACTIVITY_LABEL = 'Activity',
  IMPROVEMENTS_LABEL = 'Improvements',
  CHARGES_DESCRIPTION = 'Code this case',
  RELATED_DESCRIPTION = 'See related cases',
  ACTIVITY_DESCRIPTION = 'See changes to this case',
  IMPROVEMENTS_DESCRIPTION = 'See document improvement reasons',
  NOTES_LABEL = 'Notes',
  CODE_SOURCES = 'Code Sources',
  CODE_SOURCES_DESCRIPTION = 'See codes and their sources'
}

enum CaseAlertType {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFO = 'INFO'
}

enum CursorOperation {
  PREVIOUS = 'prev',
  NEXT = 'next'
}

enum ResponseStatus {
  SUCCESS = 'success',
  FAILURE = 'failure'
}

enum DateFilterLabelEnum {
  ALL_EVENTS = 'All Events',
  SEVEN_DAYS = '7 Days',
  THIRTY_DAYS = '30 Days',
  THREE_YEARS = '3 Years',
  ON_DOS = 'On Date of service'
}

enum ProviderType {
  BILLING_PROVIDER = 'BILLING_PROVIDER',
  REFERRING_PROVIDER = 'REFERRING_PROVIDER',
  PERFORMING_PROVIDER = 'PERFORMING_PROVIDER'
}

enum RequiredField {
  PERFORMING_PROVIDER = 'performingProviderNumber',
  DATE_OF_SERVICE = 'dateOfService',
  DEPARTMENT = 'departmentCode',
  BILLING_PROVIDER = 'billingProviderNumber',
  REFERRING_PROVIDER = 'referringProviderNumber',
  BILLING_AREA = 'feeSchedule'
}

enum HoldReasonLabel {
  HOLD = 'Hold',
  HOLD_FOR_DOCUMENTATION_QUERY = 'Hold: Documentation Query',
  HOLD_FOR_MANAGER_REVIEW = 'Hold: Manager Review',
  OFF_HOLD = 'Off Hold'
}

enum DictionaryFilterDefault {
  INCLUDE = 'Include',
  EXCLUDE = 'Exclude'
}

// Feature Flag for the code bench
enum BenchMode {
  CODE = 'CODE',
  GRADE = 'GRADE'
}

// Field Type enum, used by reusable workbench components
enum FieldType {
  SelectList = 'selectList',
  Button = 'button',
  Text = 'text',
  Icon = 'icon',
  Code = 'code',
  TextInput = 'textInput'
}

enum CodeAssessmentRiskCategory {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT',
  MISSED = 'MISSED'
}

enum CodeSearchType {
  CPT = 'CPT',
  ICD = 'ICD',
  MODIFIER = 'MODIFIER'
}

enum SugggestedCodeType {
  RELATED_CASE = 'RELATED_CASE',
  CURRENT_CASE = 'CURRENT_CASE',
  FROM_SOURCES = 'FROM_SOURCES'
}

enum CoderNotesLookupType {
  ENCOUNTER_UID = 'ENCOUNTER_UID',
  ACCESSION_NUMBER = 'ACCESSION_NUMBER'
}

enum CoderNotesLookupTypeName {
  ENCOUNTER_UID = 'encounter_uid',
  ACCESSION_NUMBER = 'accession_number',
  CQA_CODER_COMMENT = 'lookup_reference'
}

export {
  CaseAlertType,
  TitleTabsEnum,
  AmplifyCapabilities,
  CapabilityAvailabilityReason,
  DocumentQueryType,
  DocumentStatus,
  LaunchParams,
  DictionaryRequestStatus,
  ProcessInstanceActions,
  ChargeTypes,
  AmplifyErrorSources,
  AuthToken,
  AuthenticationChannelEvents,
  AccelerateProcessStatus,
  InvoiceStatus,
  InvoiceEditorMode,
  CrudOperations,
  CodeChangeType,
  EvidenceType,
  InvoiceTypes,
  Gen2CaseStatus,
  Gen2ProcessStatus,
  ChargeSessionType,
  ChargeSessionCodeType,
  ChargeSessionCodeProvenance,
  ChargeSessionProviderRole,
  NavigationAction,
  CaseStatus,
  CaseArtifactTypes,
  ArtifactTypes,
  ProcessStatus,
  ProcessRunType,
  CaseDataTypes,
  IdentifierType,
  TaskTypes,
  CaseDataGroup,
  ResourceTypes,
  SystemRole,
  ORGS,
  OrgLevels,
  FilterTypes,
  FeatureTypes,
  FeatureSources,
  Provenances,
  uiStatus,
  IdentifierTypes,
  CustomerPhase,
  CodeType,
  CaseDetailMode,
  statusColors,
  statusBGColors,
  FilterKeys,
  SpanLevel,
  TimelineStatus,
  EditorIssueLevel,
  EditorIssueProvenance,
  DictionaryStatus,
  DictionaryEditStatus,
  ServiceLines,
  UserPreferenceKey,
  UserPreferenceSection,
  PermissionLevel,
  ResourceId,
  CaseConfigSection,
  FeedbackMeta,
  UIModesEnum,
  UIViewEnum,
  CodeTypes,
  ModifierTypes,
  IssueTypeErrors,
  ProcessStatusLabel,
  ImprovementDictionaryProps,
  HoldReasonType,
  CaseAccessState,
  MiniTabLabels,
  CursorOperation,
  ResponseStatus,
  EntriesMessageType,
  DateFilterLabelEnum,
  ProcessQAStatus,
  ProviderType,
  RequiredField,
  HoldReasonLabel,
  DictionaryFilterDefault,
  BenchMode,
  FieldType,
  CodeAssessmentRiskCategory,
  CodeSearchType,
  SugggestedCodeType,
  CoderNotesLookupType,
  CoderNotesLookupTypeName,
  ConfigurationSection,
  ConfigurationKeyName
};
